import './HeroSection.scss';
import React from 'react';

const HeroSection = () => (
  <section className="hero">
    <h1 className="hero-title">HEXRD</h1>
    <p className="hero-subtitle">
      The "Highly Extensible X-Ray Diffraction Toolkit" (HEXRD) is an open
      source library for high-energy diffraction, enabling researchers to
      analyze material structures through advanced tools with a user-friendly GUI.
    </p>
  </section>
);

export default HeroSection;
